<template>
  <div class="modal-overlay web-auth-modal" v-if="visible" @click.self="close">
    <div class="modal-box">
      <div class="auth-box">
        <div class="logo">
          <div class="logo-icon"><img :src="logoImg" alt="logo" class="logo-icon-img" /></div>
          <h1>登录</h1>
          <p class="sub">登录后可交易、充值及管理账户</p>
        </div>
        
        <!-- Login mode toggle -->
        <div class="login-mode-toggle">
          <a href="javascript:void(0)" class="mode-link" :class="{ 'mode-active': loginMode === 'email' }" @click="switchLoginMode('email')">邮箱登录</a>
          <span class="mode-divider">•</span>
          <a href="javascript:void(0)" class="mode-link" :class="{ 'mode-active': loginMode === 'uid' }" @click="switchLoginMode('uid')">UID 登录</a>
        </div>
        
        <div class="form-group">
          <label>{{ loginMode === 'email' ? '邮箱' : 'UID' }}</label>
          <div class="input-wrap">
            <input 
              type="text" 
              v-model="form.account" 
              :placeholder="loginMode === 'email' ? '请输入邮箱' : '请输入 UID'" 
              :autocomplete="loginMode === 'email' ? 'email' : 'username'" 
              @keyup.enter="doLogin">
          </div>
        </div>
        <div v-if="form.account && loginMode === 'email' && !isValidEmail(form.account)" class="field-error">邮箱格式不正确</div>
        <div v-if="form.account && loginMode === 'uid' && !isValidUid(form.account)" class="field-error">UID 格式不正确（8 位大写字母 + 数字）</div>
        <div class="form-group"><label>密码</label><div class="input-wrap"><input type="password" v-model="form.password" placeholder="登录密码" autocomplete="current-password" @keyup.enter="doLogin"></div></div>
        <div v-if="form.password && form.password.length < 6" class="field-error">密码不能少于6位</div>
        <div class="form-group" v-if="captchaEnabled">
          <label>图形验证码</label>
          <div class="captcha-row">
            <div class="input-wrap" style="flex:1"><input type="text" v-model="form.captcha" placeholder="图形验证码" maxlength="4" @keyup.enter="doLogin"></div>
            <img v-if="captchaImg" :src="captchaImg" class="captcha-img" @click="refreshCaptcha" title="点击刷新验证码" alt="验证码">
          </div>
        </div>
        <div class="form-error" v-if="errorMsg">{{ errorMsg }}</div>
        <button class="btn-primary" @click="doLogin" :disabled="loading">{{ loading ? '登录中...' : '登 录' }}</button>
        
        <!-- Remember account checkbox -->
        <div class="remember-account-row" @click="toggleRememberAccount">
          <label class="remember-checkbox">
            <input type="checkbox" :checked="rememberAccount" />
            <span class="remember-text">记住账号</span>
          </label>
        </div>
        <div class="auth-link-row">
          <a href="javascript:void(0)" class="link-forgot" @click="$emit('switch-forgot')">忘记密码？</a>
          <span class="auth-link" v-if="registerEnabled">还没有账号？<a href="javascript:void(0)" @click="$emit('switch-register')">立即注册</a></span>
        </div>
      </div>
      <div style="text-align:center;margin-top:12px"><a href="javascript:void(0)" @click="close" style="color:#999;font-size:13px;text-decoration:none">关闭</a></div>
    </div>
  </div>
</template>

<script>
import { showToast } from '@/utils/common'
import { isValidEmail } from '@/utils/validate'
import { getCaptcha, getRememberedAccount, saveRememberedAccount, deleteRememberedAccount } from '@/api/auth'

export default {
  name: 'LoginModal',
  props: { visible: Boolean, registerEnabled: { type: Boolean, default: true } },
  data() {
    return {
      logoImg: require('@/assets/logo/logo-icon.png'),
      loginMode: 'email', // 'email' | 'uid'
      rememberAccount: false,
      form: { account: '', password: '', captcha: '' },
      loading: false,
      errorMsg: '',
      captchaImg: '',
      captchaUuid: '',
      captchaEnabled: true
    }
  },
  methods: {
    isValidEmail,
    isValidUid(uid) {
      return /^[A-Z0-9]{8}$/.test(uid)
    },
    close() { this.$emit('close') },
    switchLoginMode(mode) {
      this.loginMode = mode
      // 切换模式时清空验证码和密码
      this.form.captcha = ''
      this.form.password = ''
    },
    toggleRememberAccount() {
      this.rememberAccount = !this.rememberAccount
      this.onRememberAccountChange()
    },
    async onRememberAccountChange() {
      if (this.rememberAccount && this.form.account.trim()) {
        try {
          await saveRememberedAccount({
            mode: this.loginMode,
            value: this.form.account.trim()
          })
        } catch (e) {
          console.error('保存记住账号失败', e)
        }
      } else if (!this.rememberAccount) {
        try {
          await deleteRememberedAccount()
        } catch (e) {
          console.error('删除记住账号失败', e)
        }
      }
    },
    async refreshCaptcha() {
      try {
        const res = await getCaptcha()
        if (res.code === 200) {
          const data = res.data || res
          this.captchaEnabled = data.captchaEnabled !== false
          if (this.captchaEnabled) {
            this.captchaImg = 'data:image/gif;base64,' + data.img
            this.captchaUuid = data.uuid || ''
          }
        }
      } catch (e) {
        this.captchaImg = ''
      }
    },
    async doLogin() {
      this.errorMsg = ''
          
      // 根据模式进行不同的输入校验
      if (!this.form.account) {
        this.errorMsg = this.loginMode === 'email' ? '请输入邮箱' : '请输入 UID'
        return
      }
          
      if (this.loginMode === 'email') {
        if (!isValidEmail(this.form.account)) {
          this.errorMsg = '邮箱格式不正确'
          return
        }
      } else {
        if (!this.isValidUid(this.form.account)) {
          this.errorMsg = 'UID 格式不正确（8 位大写字母 + 数字）'
          return
        }
      }
          
      if (!this.form.password) { this.errorMsg = '请输入密码'; return }
      if (this.form.password.length < 6) { this.errorMsg = '密码不能少于 6 位'; return }
      if (!this.form.captcha && this.captchaEnabled) { this.errorMsg = '请输入验证码'; return }
          
      this.loading = true
      try {
        // 构建登录参数
        const loginParams = {
          password: this.form.password,
          code: this.form.captcha,
          uuid: this.captchaUuid
        }
        loginParams[this.loginMode] = this.form.account.trim()
            
        await this.$store.dispatch('user/login', loginParams)

        // 登录成功后保存账号到 Redis（如果勾选了记住账号）
        if (this.rememberAccount && this.form.account.trim()) {
          try {
            await saveRememberedAccount({
              mode: this.loginMode,
              value: this.form.account.trim()
            })
          } catch (e) {
            console.error('保存记住账号失败', e)
          }
        }

        showToast('登录成功')
        this.form = { account: '', password: '', captcha: '' }
        this.$emit('login-success')
        this.close()
      } catch (e) {
        this.errorMsg = e.message || '登录失败，请检查邮箱和密码'
        this.refreshCaptcha()
      }
      this.loading = false
    }
  },
  watch: {
    async visible(v) {
      if (v) {
        this.form = { account: '', password: '', captcha: '' }
        this.errorMsg = ''
        this.refreshCaptcha()
        
        // 从 Redis 恢复已记住的账号
        try {
          const res = await getRememberedAccount()
          if (res && res.data && res.data.value) {
            this.rememberAccount = true
            this.loginMode = res.data.mode || 'email'
            this.form.account = res.data.value
          } else {
            this.rememberAccount = false
            // 兼容旧版 localStorage 数据（一次性迁移）
            const legacy = localStorage.getItem('rememberedAccount')
            if (legacy) {
              try {
                const data = JSON.parse(legacy)
                this.rememberAccount = true
                this.loginMode = data.mode || 'email'
                this.form.account = data.value || ''
                // 迁移到 Redis 后清除旧数据
                await saveRememberedAccount({ mode: this.loginMode, value: this.form.account })
                localStorage.removeItem('rememberedAccount')
              } catch (e) {
                console.error('解析旧版记住账号失败', e)
              }
            }
          }
        } catch (e) {
          console.error('获取记住账号失败', e)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.web-auth-modal .modal-box { width: 420px; padding: 32px 40px; }
.auth-box { width: 100%; }
.auth-box .logo { text-align: center; margin-bottom: 32px; }
.auth-box .logo-icon {
  width: 56px; height: 56px; background: transparent; border-radius: 14px;
  margin: 0 auto 12px; display: flex; align-items: center; justify-content: center;
}
.auth-box .logo-icon-img {
  width: 56px; height: 56px;
}
.auth-box h1 { font-size: 22px; text-align: center; }
.auth-box .sub { text-align: center; color: var(--text-secondary); font-size: 13px; margin-top: 4px; }

/* Login Mode Toggle */
.login-mode-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  font-size: 14px;
}

.mode-link {
  color: var(--text-secondary);
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;
  
  &:hover {
    color: var(--red);
  }
  
  &.mode-active {
    color: var(--red);
    font-weight: 600;
  }
}

.mode-divider {
  color: var(--text-secondary);
  margin: 0 12px;
}
.captcha-row {
  display: flex; gap: 10px; align-items: center;
}
.captcha-img {
  height: 42px; border-radius: 6px; cursor: pointer; border: 1px solid var(--border);
  flex-shrink: 0;
}
.field-error { font-size: 12px; color: var(--red); margin-top: -8px; margin-bottom: 12px; }
.form-error { text-align: center; color: var(--red); font-size: 13px; margin-top: 12px; }
.btn-primary {
  width: 100%; padding: 12px; background: var(--red); color: #fff;
  border: none; border-radius: 6px; font-size: 15px; font-weight: 600;
  cursor: pointer; font-family: inherit;
  &:hover { opacity: .92; } &:disabled { opacity: .5; cursor: not-allowed; }
}

/* Remember Account Row */
.remember-account-row {
  display: flex;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 12px;
}

.remember-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  
  input[type="checkbox"] {
    margin-right: 6px;
    cursor: pointer;
  }
  
  .remember-text {
    color: var(--text-secondary);
    user-select: none;
  }
}
.auth-link-row { display: flex; align-items: center; justify-content: space-between; margin-top: 16px; font-size: 14px; }
.auth-link { color: var(--text-secondary); a { color: var(--red); text-decoration: none; font-weight: 600; } }
.link-forgot { color: var(--red); text-decoration: none; font-weight: 600; font-size: 14px; }
</style>
